export const featuredArticle = {
  id: 1,
  title: 'Chim Sẻ Đi Nắng Phá Vỡ Kỷ Lục Tại Giải AOE 2025',
  slug: 'chim-se-di-nang-pha-vo-ky-luc-tai-giai-aoe-2025',
  excerpt: 'Huyền thoại AOE Việt Nam tiếp tục khẳng định đẳng cấp với chiến thắng áp đảo tại giải đấu lớn nhất năm, thiết lập kỷ lục mới về thời gian chiến thắng nhanh nhất.',
  game: 'Age of Empires',
  category: 'Game Thủ',
  image: 'https://public.readdy.ai/ai/img_res/c1f5425e1acd6154418b39e36b626e7e.jpg',
  author: {
    name: 'Minh Tuấn',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20gaming%20journalist%20avatar%20portrait%2C%20friendly%20smile%2C%20modern%20style%2C%20clean%20background%2C%20high%20quality%20headshot%20photography&width=100&height=100&seq=author-1&orientation=squarish',
    role: 'Biên tập viên Gaming'
  },
  date: '2025-01-15',
  readTime: '5 phút đọc',
  views: '1.2M',
  tags: ['AOE', 'Chim Sẻ Đi Nắng', 'Esports', 'Giải đấu']
};

export const articles = [
  // TIN GAME ARTICLES
  {
    id: 31,
    title: 'Hướng Dẫn Nạp Tiền Iwin68 Nhanh – Bảo Mật – Không Lỗi 2025',
    slug: 'huong-dan-nap-tien-iwin68-nhanh-bao-mat-khong-loi-2025',
    excerpt: 'Trong thế giới cá cược trực tuyến, yếu tố nhanh – chuẩn – an toàn luôn là kim chỉ nam của mọi giao dịch. Hướng dẫn chi tiết cách nạp tiền iwin68 siêu tốc, không lỗi và bảo mật tuyệt đối.',
    content: '',
    image: 'https://readdy.ai/api/search-image?query=secure%20online%20payment%20transaction%2C%20digital%20wallet%2C%20banking%20app%20interface%2C%20modern%20technology%2C%20safe%20and%20fast%2C%20professional%20lighting&width=800&height=600&seq=iwin68-main&orientation=landscape',
    category: 'Tin Game',
    game: 'Tin Game',
    author: {
      name: 'Minh Tuấn',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20vietnamese%20tech%20writer%20portrait%2C%20male%2C%20friendly%20smile%2C%20modern%20office%20background%2C%20professional%20headshot&width=200&height=200&seq=author-minhtuan&orientation=squarish',
      role: 'Chuyên gia Công nghệ'
    },
    date: '2025-01-16',
    readTime: '8 phút đọc',
    views: '2.5M'
  },
  {
    id: 32,
    title: 'Top 5 Game Mobile Hay Nhất Tháng 1/2025 - Không Thể Bỏ Lỡ',
    slug: 'top-5-game-mobile-hay-nhat-thang-1-2025',
    excerpt: 'Điểm danh 5 tựa game mobile được đánh giá cao nhất trong tháng đầu năm 2025, từ RPG hành động đến game chiến thuật đầy hấp dẫn. Mỗi tựa game đều mang lại trải nghiệm độc đáo và gameplay sáng tạo.',
    game: 'Tin Game',
    category: 'Tin Game',
    image: 'https://readdy.ai/api/search-image?query=mobile%20gaming%20collection%20showcasing%20various%20popular%20games%20on%20smartphone%20screen%2C%20colorful%20game%20interfaces%2C%20modern%20mobile%20device%2C%20vibrant%20gaming%20graphics&width=800&height=600&seq=mobile-games-2025&orientation=landscape',
    author: {
      name: 'Hoàng Anh',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20mobile%20gaming%20reviewer%20avatar%2C%20young%20male%2C%20casual%20modern%20style%2C%20friendly%20expression%2C%20tech%20background&width=100&height=100&seq=author-hoanganh&orientation=squarish',
      role: 'Chuyên gia Game Mobile'
    },
    date: '2025-01-15',
    readTime: '10 phút đọc',
    views: '1.8M',
    tags: ['Game Mobile', 'Top Game', 'Review', '2025']
  },
  {
    id: 33,
    title: 'Steam Deck vs Nintendo Switch OLED - Cuộc Đua Handheld Gaming 2025',
    slug: 'steam-deck-vs-nintendo-switch-oled-cuoc-dua-handheld-gaming-2025',
    excerpt: 'So sánh chi tiết hai máy chơi game cầm tay hàng đầu hiện tại. Phân tích về hiệu năng, thư viện game, giá cả và trải nghiệm người dùng để giúp bạn đưa ra lựa chọn phù hợp nhất.',
    game: 'Tin Game',
    category: 'Tin Game',
    image: 'https://readdy.ai/api/search-image?query=steam%20deck%20and%20nintendo%20switch%20oled%20side%20by%20side%20comparison%2C%20modern%20handheld%20gaming%20devices%2C%20professional%20product%20photography%2C%20clean%20background&width=800&height=600&seq=handheld-comparison&orientation=landscape',
    author: {
      name: 'Quang Minh',
      avatar: 'https://readdy.ai/api/search-image?query=gaming%20hardware%20expert%20portrait%2C%20male%2C%20professional%20tech%20reviewer%2C%20modern%20office%20setup%2C%20confident%20expression&width=100&height=100&seq=author-quangminh&orientation=squarish',
      role: 'Chuyên gia Phần cứng'
    },
    date: '2025-01-14',
    readTime: '12 phút đọc',
    views: '1.5M',
    tags: ['Steam Deck', 'Nintendo Switch', 'Handheld', 'So sánh']
  },
  {
    id: 34,
    title: 'VNG và Garena - Cuộc Chiến Phát Hành Game Tại Việt Nam',
    slug: 'vng-va-garena-cuoc-chien-phat-hanh-game-tai-viet-nam',
    excerpt: 'Phân tích sâu về cuộc cạnh tranh giữa hai ông lớn phát hành game tại Việt Nam. Từ chiến lược kinh doanh, danh mục sản phẩm đến tác động lên thị trường game Việt trong những năm qua.',
    game: 'Tin Game',
    category: 'Tin Game',
    image: 'https://readdy.ai/api/search-image?query=vietnamese%20gaming%20industry%20competition%2C%20office%20buildings%20representing%20gaming%20companies%2C%20modern%20business%20district%2C%20professional%20corporate%20photography&width=800&height=600&seq=gaming-industry-vn&orientation=landscape',
    author: {
      name: 'Thanh Tùng',
      avatar: 'https://readdy.ai/api/search-image?query=business%20gaming%20analyst%20portrait%2C%20professional%20male%2C%20suit%20and%20tie%2C%20corporate%20background%2C%20serious%20expression&width=100&height=100&seq=author-thanhtung&orientation=squarish',
      role: 'Phân tích viên Thị trường'
    },
    date: '2025-01-13',
    readTime: '15 phút đọc',
    views: '1.3M',
    tags: ['VNG', 'Garena', 'Thị trường game', 'Phân tích']
  },
  {
    id: 35,
    title: 'Xu Hướng Game Việt Nam 2025 - AI và Công Nghệ Mới',
    slug: 'xu-huong-game-viet-nam-2025-ai-va-cong-nghe-moi',
    excerpt: 'Dự đoán những xu hướng công nghệ mới sẽ thay đổi ngành game Việt Nam trong năm 2025. Từ trí tuệ nhân tạo, thực tế ảo đến blockchain gaming và những cơ hội phát triển mới.',
    game: 'Tin Game',
    category: 'Tin Game',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20gaming%20technology%20concept%2C%20AI%20and%20virtual%20reality%20elements%2C%20modern%20gaming%20setup%20with%20holographic%20interfaces%2C%20high-tech%20atmosphere&width=800&height=600&seq=gaming-future-2025&orientation=landscape',
    author: {
      name: 'Dr. Hải Nam',
      avatar: 'https://readdy.ai/api/search-image?query=tech%20expert%20scientist%20portrait%2C%20middle-aged%20male%2C%20glasses%2C%20professional%20academic%20background%2C%20intelligent%20expression&width=100&height=100&seq=author-hainam&orientation=squarish',
      role: 'Chuyên gia Công nghệ'
    },
    date: '2025-01-12',
    readTime: '14 phút đọc',
    views: '1.1M',
    tags: ['Xu hướng', 'AI Gaming', 'Công nghệ', '2025']
  },

  // FIFA ONLINE 4 ARTICLES
  {
    id: 2,
    title: 'Top 10 Cầu Thủ FIFA Online 4 Việt Nam Xuất Sắc Nhất 2025',
    slug: 'top-10-cau-thu-fifa-online-4-viet-nam-xuat-sac-nhat-2025',
    excerpt: 'Điểm danh những tên tuổi lớn nhất làng FIFA Online 4 Việt Nam với kỹ năng điều khiển siêu đẳng và thành tích ấn tượng trong năm qua.',
    game: 'FIFA Online 4',
    category: 'Game Thủ',
    image: 'https://readdy.ai/api/search-image?query=fifa%20online%20soccer%20game%20action%20screenshot%2C%20professional%20player%20controlling%20ball%2C%20stadium%20atmosphere%2C%20vibrant%20green%20field%2C%20dynamic%20gameplay%20moment%2C%20high%20quality%20gaming%20graphics&width=800&height=600&seq=article-2&orientation=landscape',
    author: {
      name: 'Hoàng Nam',
      avatar: 'https://readdy.ai/api/search-image?query=young%20male%20gaming%20writer%20avatar%20portrait%2C%20casual%20style%2C%20modern%20background%2C%20professional%20headshot%20photography&width=100&height=100&seq=author-2&orientation=squarish',
      role: 'Chuyên gia FIFA'
    },
    date: '2025-01-14',
    readTime: '8 phút đọc',
    views: '856K',
    tags: ['FIFA Online 4', 'Top 10', 'Game thủ']
  },
  {
    id: 6,
    title: 'Chân Dung Huy Popper - Vua FIFA Việt Nam',
    slug: 'chan-dung-huy-popper-vua-fifa-viet-nam',
    excerpt: 'Tìm hiểu về Huy Popper, game thủ FIFA Online 4 tài năng với lối chơi sáng tạo và thành tích đáng nể trong cộng đồng.',
    game: 'FIFA Online 4',
    category: 'Game Thủ',
    image: 'https://readdy.ai/api/search-image?query=fifa%20online%20gaming%20setup%20with%20player%20celebrating%20goal%2C%20excited%20expression%2C%20gaming%20monitor%20showing%20soccer%20match%2C%20modern%20gaming%20room%2C%20vibrant%20atmosphere&width=800&height=600&seq=article-6&orientation=landscape',
    author: {
      name: 'Hoàng Nam',
      avatar: 'https://readdy.ai/api/search-image?query=young%20male%20gaming%20writer%20avatar%20portrait%2C%20casual%20style%2C%20modern%20background%2C%20professional%20headshot%20photography&width=100&height=100&seq=author-2&orientation=squarish',
      role: 'Chuyên gia FIFA'
    },
    date: '2025-01-10',
    readTime: '6 phút đọc',
    views: '745K',
    tags: ['FIFA Online 4', 'Huy Popper', 'Game thủ']
  },
  {
    id: 10,
    title: 'Độ Mixi Và Hành Trình Chinh Phục FIFA Online 4',
    slug: 'do-mixi-va-hanh-trinh-chinh-phuc-fifa-online-4',
    excerpt: 'Streamer nổi tiếng Độ Mixi chia sẻ về hành trình chinh phục FIFA Online 4, từ những ngày đầu mới chơi đến khi trở thành một trong những streamer FIFA hàng đầu Việt Nam.',
    game: 'FIFA Online 4',
    category: 'Game Thủ',
    image: 'https://readdy.ai/api/search-image?query=popular%20vietnamese%20streamer%20playing%20fifa%20online%2C%20gaming%20setup%20with%20multiple%20monitors%2C%20energetic%20atmosphere%2C%20modern%20streaming%20room&width=800&height=600&seq=article-10&orientation=landscape',
    author: {
      name: 'Hoàng Nam',
      avatar: 'https://readdy.ai/api/search-image?query=young%20male%20gaming%20writer%20avatar%20portrait%2C%20casual%20style%2C%20modern%20background%2C%20professional%20headshot%20photography&width=100&height=100&seq=author-2&orientation=squarish',
      role: 'Chuyên gia FIFA'
    },
    date: '2025-01-06',
    readTime: '9 phút đọc',
    views: '2.3M',
    tags: ['FIFA Online 4', 'Độ Mixi', 'Streamer']
  },
  {
    id: 36,
    title: 'Hướng Dẫn Build Đội Hình FIFA Online 4 Meta 2025',
    slug: 'huong-dan-build-doi-hinh-fifa-online-4-meta-2025',
    excerpt: 'Phân tích chi tiết các đội hình mạnh nhất trong meta FIFA Online 4 năm 2025. Từ lựa chọn cầu thủ, sơ đồ chiến thuật đến cách phân bổ ngân sách hiệu quả cho team của bạn.',
    game: 'FIFA Online 4',
    category: 'Hướng Dẫn',
    image: 'https://readdy.ai/api/search-image?query=fifa%20online%20team%20formation%20tactical%20board%2C%20soccer%20strategy%20planning%2C%20player%20cards%20arrangement%2C%20professional%20coaching%20setup%2C%20tactical%20analysis&width=800&height=600&seq=fifa-tactics-2025&orientation=landscape',
    author: {
      name: 'Minh Đức',
      avatar: 'https://readdy.ai/api/search-image?query=fifa%20tactical%20expert%20portrait%2C%20male%20coach%2C%20professional%20sports%20analyst%2C%20whiteboard%20background%2C%20confident%20expression&width=100&height=100&seq=author-minhduc&orientation=squarish',
      role: 'Huấn luyện viên FIFA'
    },
    date: '2025-01-11',
    readTime: '12 phút đọc',
    views: '1.4M',
    tags: ['FIFA Online 4', 'Đội hình', 'Meta', 'Hướng dẫn']
  },
  {
    id: 37,
    title: 'Bí Kíp Kiếm FC Nhanh Trong FIFA Online 4 - Update 2025',
    slug: 'bi-kip-kiem-fc-nhanh-trong-fifa-online-4-update-2025',
    excerpt: 'Những phương pháp hiệu quả nhất để kiếm FC trong FIFA Online 4. Từ chế độ chơi có lợi nhuận cao, trading cầu thủ thông minh đến các sự kiện đặc biệt không thể bỏ lỡ.',
    game: 'FIFA Online 4',
    category: 'Hướng Dẫn',
    image: 'https://readdy.ai/api/search-image?query=fifa%20online%20currency%20management%2C%20digital%20coins%20and%20rewards%2C%20gaming%20economy%20interface%2C%20financial%20success%20in%20football%20game&width=800&height=600&seq=fifa-fc-earning&orientation=landscape',
    author: {
      name: 'Văn Tài',
      avatar: 'https://readdy.ai/api/search-image?query=fifa%20trading%20expert%20portrait%2C%20young%20male%20gamer%2C%20calculator%20and%20charts%20background%2C%20smart%20investor%20look&width=100&height=100&seq=author-vantai&orientation=squarish',
      role: 'Chuyên gia Trading FIFA'
    },
    date: '2025-01-09',
    readTime: '10 phút đọc',
    views: '1.9M',
    tags: ['FIFA Online 4', 'Kiếm FC', 'Trading', 'Mẹo hay']
  },

  // AGE OF EMPIRES ARTICLES
  {
    id: 7,
    title: 'BiBi - Tài Năng Trẻ Làm Rạng Danh AOE Việt',
    slug: 'bibi-tai-nang-tre-lam-rang-danh-aoe-viet',
    excerpt: 'Sự trỗi dậy của BiBi trong làng AOE Việt Nam, game thủ trẻ với lối chơi táo bạo và chiến thuật độc đáo.',
    game: 'Age of Empires',
    category: 'Game Thủ',
    image: 'https://readdy.ai/api/search-image?query=age%20of%20empires%20strategy%20game%20battle%20scene%2C%20medieval%20armies%20clashing%2C%20castle%20siege%20warfare%2C%20detailed%20rts%20gameplay%20graphics%2C%20epic%20scale&width=800&height=600&seq=article-7&orientation=landscape',
    author: {
      name: 'Thu Hà',
      avatar: 'https://readdy.ai/api/search-image?query=female%20gaming%20journalist%20avatar%20portrait%2C%20professional%20style%2C%20friendly%20expression%2C%20modern%20background%2C%20high%20quality%20headshot&width=100&height=100&seq=author-3&orientation=squarish',
      role: 'Biên tập viên LMHT'
    },
    date: '2025-01-09',
    readTime: '7 phút đọc',
    views: '534K',
    tags: ['AOE', 'BiBi', 'Tài năng trẻ']
  },
  {
    id: 9,
    title: 'So Sánh AOE1 vs AOE2: Nên Chơi Game Nào?',
    slug: 'so-sanh-aoe1-vs-aoe2-nen-choi-game-nao',
    excerpt: 'Phân tích chi tiết sự khác biệt giữa Age of Empires 1 và 2, giúp bạn lựa chọn phiên bản phù hợp với phong cách chơi.',
    game: 'Age of Empires',
    category: 'Hướng Dẫn',
    image: 'https://readdy.ai/api/search-image?query=age%20of%20empires%20game%20comparison%20split%20screen%2C%20medieval%20strategy%20gameplay%2C%20castle%20building%2C%20army%20management%2C%20detailed%20rts%20graphics&width=800&height=600&seq=article-9&orientation=landscape',
    author: {
      name: 'Minh Tuấn',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20gaming%20journalist%20avatar%20portrait%2C%20friendly%20smile%2C%20modern%20style%2C%20clean%20background%2C%20high%20quality%20headshot%20photography&width=100&height=100&seq=author-1&orientation=squarish',
      role: 'Biên tập viên Gaming'
    },
    date: '2025-01-07',
    readTime: '8 phút đọc',
    views: '892K',
    tags: ['AOE', 'So sánh', 'Hướng dẫn']
  },
  {
    id: 14,
    title: 'Lịch Sử Phát Triển AOE Tại Việt Nam',
    slug: 'lich-su-phat-trien-aoe-tai-viet-nam',
    excerpt: 'Nhìn lại chặng đường phát triển của Age of Empires tại Việt Nam, từ những ngày đầu tiên đến khi trở thành bộ môn esports được yêu thích nhất.',
    game: 'Age of Empires',
    category: 'Tin Game',
    image: 'https://readdy.ai/api/search-image?query=age%20of%20empires%20tournament%20in%20vietnam%2C%20players%20competing%2C%20audience%20watching%2C%20esports%20event%20atmosphere&width=800&height=600&seq=article-14&orientation=landscape',
    author: {
      name: 'Thu Hà',
      avatar: 'https://readdy.ai/api/search-image?query=female%20gaming%20journalist%20avatar%20portrait%2C%20professional%20style%2C%20friendly%20expression%2C%20modern%20background%2C%20high%20quality%20headshot&width=100&height=100&seq=author-3&orientation=squarish',
      role: 'Biên tập viên LMHT'
    },
    date: '2025-01-02',
    readTime: '15 phút đọc',
    views: '1.2M',
    tags: ['AOE', 'Lịch sử', 'Việt Nam', 'Esports']
  },
  {
    id: 38,
    title: 'Hướng Dẫn Micro Control Chuyên Nghiệp Trong AOE',
    slug: 'huong-dan-micro-control-chuyen-nghiep-trong-aoe',
    excerpt: 'Những kỹ thuật micro control cần thiết để trở thành pro player AOE. Từ quản lý đơn vị cơ bản đến các combo nâng cao, giúp nâng cao trình độ chơi game đáng kể.',
    game: 'Age of Empires',
    category: 'Hướng Dẫn',
    image: 'https://readdy.ai/api/search-image?query=age%20of%20empires%20micro%20management%20gameplay%2C%20detailed%20unit%20control%2C%20strategic%20army%20positioning%2C%20professional%20gaming%20hands%20on%20keyboard%20and%20mouse&width=800&height=600&seq=aoe-micro-control&orientation=landscape',
    author: {
      name: 'Chim Sẻ Đi Nắng',
      avatar: 'https://readdy.ai/api/search-image?query=legendary%20aoe%20player%20avatar%2C%20focused%20gaming%20expression%2C%20professional%20esports%20champion%2C%20victory%20celebration%20background&width=100&height=100&seq=author-chimsedinage&orientation=squarish',
      role: 'Huyền thoại AOE'
    },
    date: '2025-01-08',
    readTime: '13 phút đọc',
    views: '1.6M',
    tags: ['AOE', 'Micro Control', 'Kỹ thuật', 'Pro']
  },
  {
    id: 39,
    title: 'Top 5 Build Order AOE2 Mạnh Nhất Meta Hiện Tại',
    slug: 'top-5-build-order-aoe2-manh-nhat-meta-hien-tai',
    excerpt: 'Phân tích 5 build order được các pro player sử dụng nhiều nhất trong meta AOE2 hiện tại. Chi tiết từng bước thực hiện và tình huống áp dụng phù hợp nhất.',
    game: 'Age of Empires',
    category: 'Hướng Dẫn',
    image: 'https://readdy.ai/api/search-image?query=age%20of%20empires%202%20economic%20build%20strategy%2C%20medieval%20village%20development%2C%20resource%20management%2C%20strategic%20planning%20interface&width=800&height=600&seq=aoe2-build-order&orientation=landscape',
    author: {
      name: 'Gunny Mobi',
      avatar: 'https://readdy.ai/api/search-image?query=aoe%20strategy%20expert%20portrait%2C%20tactical%20analyst%2C%20professional%20gaming%20coach%2C%20medieval%20theme%20background&width=100&height=100&seq=author-gunnymobi&orientation=squarish',
      role: 'Chuyên gia Chiến thuật AOE'
    },
    date: '2025-01-05',
    readTime: '11 phút đọc',
    views: '1.3M',
    tags: ['AOE2', 'Build Order', 'Meta', 'Chiến thuật']
  },

  // LIÊN MINH HUYỀN THOẠI ARTICLES
  {
    id: 3,
    title: 'SofM - Niềm Tự Hào LMHT Việt Nam Tại LPL',
    slug: 'sofm-niem-tu-hao-lmht-viet-nam-tai-lpl',
    excerpt: 'Hành trình từ VCS đến LPL của SofM, game thủ Việt Nam duy nhất thi đấu tại giải đấu LMHT hàng đầu thế giới với phong độ ấn tượng.',
    game: 'Liên Minh Huyền Thoại',
    category: 'Game Thủ',
    image: 'https://readdy.ai/api/search-image?query=league%20of%20legends%20professional%20player%20at%20gaming%20desk%2C%20focused%20expression%2C%20team%20jersey%2C%20modern%20esports%20facility%2C%20dramatic%20lighting%2C%20high%20quality%20photography&width=800&height=600&seq=article-3&orientation=landscape',
    author: {
      name: 'Thu Hà',
      avatar: 'https://readdy.ai/api/search-image?query=female%20gaming%20journalist%20avatar%20portrait%2C%20professional%20style%2C%20friendly%20expression%2C%20modern%20background%2C%20high%20quality%20headshot&width=100&height=100&seq=author-3&orientation=squarish',
      role: 'Biên tập viên LMHT'
    },
    date: '2025-01-13',
    readTime: '10 phút đọc',
    views: '1.5M',
    tags: ['LMHT', 'SofM', 'LPL', 'Pro Player']
  },
  {
    id: 8,
    title: 'GAM Esports: Hành Trình Tạo Nên Lịch Sử',
    slug: 'gam-esports-hanh-trinh-tao-nen-lich-su',
    excerpt: 'Nhìn lại những khoảnh khắc đáng nhớ của GAM Esports tại các giải đấu quốc tế, đội tuyển LMHT tự hào của Việt Nam.',
    game: 'Liên Minh Huyền Thoại',
    category: 'Esports',
    image: 'https://readdy.ai/api/search-image?query=esports%20team%20celebrating%20on%20stage%20at%20international%20tournament%2C%20team%20jerseys%2C%20trophy%20presentation%2C%20excited%20players%2C%20professional%20event%20photography&width=800&height=600&seq=article-8&orientation=landscape',
    author: {
      name: 'Đức Anh',
      avatar: 'https://readdy.ai/api/search-image?query=male%20esports%20coach%20avatar%20portrait%2C%20confident%20look%2C%20gaming%20headset%2C%20professional%20photography%2C%20modern%20style&width=100&height=100&seq=author-4&orientation=squarish',
      role: 'Huấn luyện viên CS:GO'
    },
    date: '2025-01-08',
    readTime: '12 phút đọc',
    views: '1.8M',
    tags: ['LMHT', 'GAM Esports', 'Lịch sử']
  },
  {
    id: 11,
    title: 'Levi - Từ VCS Đến Giấc Mơ Thế Giới',
    slug: 'levi-tu-vcs-den-giac-mo-the-gioi',
    excerpt: 'Câu chuyện về Levi, tuyển thủ LMHT tài năng của Việt Nam với hành trình từ VCS đến các giải đấu quốc tế, mang theo hy vọng của cả một cộng đồng.',
    game: 'Liên Minh Huyền Thoại',
    category: 'Game Thủ',
    image: 'https://readdy.ai/api/search-image?query=professional%20league%20of%20legends%20player%20at%20tournament%2C%20focused%20gameplay%2C%20team%20jersey%2C%20competitive%20gaming%20environment&width=800&height=600&seq=article-11&orientation=landscape',
    author: {
      name: 'Thu Hà',
      avatar: 'https://readdy.ai/api/search-image?query=female%20gaming%20journalist%20avatar%20portrait%2C%20professional%20style%2C%20friendly%20expression%2C%20modern%20background%2C%20high%20quality%20headshot&width=100&height=100&seq=author-3&orientation=squarish',
      role: 'Biên tập viên LMHT'
    },
    date: '2025-01-05',
    readTime: '11 phút đọc',
    views: '1.9M',
    tags: ['LMHT', 'Levi', 'VCS', 'Pro Player']
  },
  {
    id: 40,
    title: 'Phân Tích Meta LMHT Mùa 15 - Những Thay Đổi Quan Trọng',
    slug: 'phan-tich-meta-lmht-mua-15-nhung-thay-doi-quan-trong',
    excerpt: 'Tổng quan về meta Liên Minh Huyền Thoại mùa giải 2025 với những thay đổi lớn về vật phẩm, tướng mạnh và chiến thuật mới. Hướng dẫn chi tiết để thích nghi nhanh nhất.',
    game: 'Liên Minh Huyền Thoại',
    category: 'Hướng Dẫn',
    image: 'https://readdy.ai/api/search-image?query=league%20of%20legends%20season%2015%20champion%20select%20screen%2C%20meta%20analysis%20interface%2C%20professional%20gaming%20setup%2C%20strategic%20planning&width=800&height=600&seq=lol-meta-s15&orientation=landscape',
    author: {
      name: 'Kiaya',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20lol%20analyst%20portrait%2C%20female%20gaming%20expert%2C%20strategic%20mindset%2C%20esports%20background%2C%20confident%20expression&width=100&height=100&seq=author-kiaya&orientation=squarish',
      role: 'Chuyên gia Meta LMHT'
    },
    date: '2025-01-04',
    readTime: '16 phút đọc',
    views: '2.1M',
    tags: ['LMHT', 'Meta', 'Mùa 15', 'Phân tích']
  },
  {
    id: 41,
    title: 'Top 10 Tướng LMHT Dễ Lên Rank Nhất 2025',
    slug: 'top-10-tuong-lmht-de-len-rank-nhat-2025',
    excerpt: 'Danh sách những vị tướng có tỷ lệ thắng cao và dễ sử dụng nhất để leo rank trong meta hiện tại. Phân tích kỹ năng, build item và cách chơi tối ưu cho từng vị trí.',
    game: 'Liên Minh Huyền Thoại',
    category: 'Hướng Dẫn',
    image: 'https://readdy.ai/api/search-image?query=league%20of%20legends%20champion%20tier%20list%2C%20powerful%20heroes%20showcase%2C%20ranking%20visualization%2C%20competitive%20gaming%20interface&width=800&height=600&seq=lol-tier-list-2025&orientation=landscape',
    author: {
      name: 'Zeros',
      avatar: 'https://readdy.ai/api/search-image?query=high%20rank%20lol%20player%20portrait%2C%20challenger%20badge%2C%20professional%20gamer%20setup%2C%20focused%20gaming%20expression&width=100&height=100&seq=author-zeros&orientation=squarish',
      role: 'Challenger LMHT'
    },
    date: '2025-01-03',
    readTime: '14 phút đọc',
    views: '2.4M',
    tags: ['LMHT', 'Rank', 'Tier List', 'Champion']
  },

  // CS:GO ARTICLES  
  {
    id: 4,
    title: 'Hướng Dẫn Train Aim Như Pro Player CS:GO',
    slug: 'huong-dan-train-aim-nhu-pro-player-csgo',
    excerpt: 'Bí quyết luyện tập aim từ các pro player hàng đầu thế giới, giúp bạn cải thiện kỹ năng bắn súng và phản xạ trong CS:GO.',
    game: 'CS:GO',
    category: 'Hướng Dẫn',
    image: 'https://readdy.ai/api/search-image?query=csgo%20counter%20strike%20gameplay%20first%20person%20shooter%2C%20aiming%20down%20sights%2C%20tactical%20shooting%20scene%2C%20competitive%20gaming%20graphics%2C%20intense%20action%20moment&width=800&height=600&seq=article-4&orientation=landscape',
    author: {
      name: 'Đức Anh',
      avatar: 'https://readdy.ai/api/search-image?query=male%20esports%20coach%20avatar%20portrait%2C%20confident%20look%2C%20gaming%20headset%2C%20professional%20photography%2C%20modern%20style&width=100&height=100&seq=author-4&orientation=squarish',
      role: 'Huấn luyện viên CS:GO'
    },
    date: '2025-01-12',
    readTime: '7 phút đọc',
    views: '623K',
    tags: ['CS:GO', 'Hướng dẫn', 'Training']
  },
  {
    id: 12,
    title: 'XuanBac - Huyền Thoại AWP Của CS:GO Việt',
    slug: 'xuanbac-huyen-thoai-awp-cua-csgo-viet',
    excerpt: 'Tìm hiểu về XuanBac, game thủ CS:GO huyền thoại với khả năng sử dụng AWP đỉnh cao, là niềm tự hào của cộng đồng CS:GO Việt Nam.',
    game: 'CS:GO',
    category: 'Game Thủ',
    image: 'https://readdy.ai/api/search-image?query=csgo%20professional%20player%20with%20awp%20sniper%20rifle%2C%20intense%20gaming%20moment%2C%20competitive%20match%2C%20focused%20expression&width=800&height=600&seq=article-12&orientation=landscape',
    author: {
      name: 'Đức Anh',
      avatar: 'https://readdy.ai/api/search-image?query=male%20esports%20coach%20avatar%20portrait%2C%20confident%20look%2C%20gaming%20headset%2C%20professional%20photography%2C%20modern%20style&width=100&height=100&seq=author-4&orientation=squarish',
      role: 'Huấn luyện viên CS:GO'
    },
    date: '2025-01-04',
    readTime: '8 phút đọc',
    views: '1.5M',
    tags: ['CS:GO', 'XuanBac', 'AWP', 'Pro Player']
  },
  {
    id: 42,
    title: 'Phân Tích Map Mirage CS:GO - Chiến Thuật Và Smoke Spots',
    slug: 'phan-tich-map-mirage-csgo-chien-thuat-va-smoke-spots',
    excerpt: 'Hướng dẫn chi tiết về map Mirage - một trong những map phổ biến nhất CS:GO. Phân tích các vị trí quan trọng, smoke spots cần thiết và chiến thuật cho cả hai phe T và CT.',
    game: 'CS:GO',
    category: 'Hướng Dẫn',
    image: 'https://readdy.ai/api/search-image?query=csgo%20mirage%20map%20tactical%20overview%2C%20smoke%20grenade%20positions%2C%20strategic%20callouts%2C%20competitive%20gaming%20analysis%2C%20detailed%20map%20layout&width=800&height=600&seq=csgo-mirage-guide&orientation=landscape',
    author: {
      name: 'Flash Gaming',
      avatar: 'https://readdy.ai/api/search-image?query=csgo%20tactical%20analyst%20portrait%2C%20professional%20esports%20coach%2C%20strategy%20expert%2C%20map%20analysis%20background&width=100&height=100&seq=author-flashgaming&orientation=squarish',
      role: 'Chuyên gia Chiến thuật CS:GO'
    },
    date: '2025-01-06',
    readTime: '12 phút đọc',
    views: '1.1M',
    tags: ['CS:GO', 'Mirage', 'Chiến thuật', 'Map Guide']
  },
  {
    id: 43,
    title: 'Top 5 Setting CS:GO Tối Ưu Để Aim Chuẩn Hơn',
    slug: 'top-5-setting-csgo-toi-uu-de-aim-chuan-hon',
    excerpt: 'Những setting quan trọng nhất trong CS:GO giúp cải thiện độ chính xác aim. Từ sensitivity, crosshair, FPS config đến các thiết lập nâng cao từ pro player.',
    game: 'CS:GO',
    category: 'Hướng Dẫn',
    image: 'https://readdy.ai/api/search-image?query=csgo%20game%20settings%20configuration%20interface%2C%20professional%20gaming%20setup%2C%20precision%20aiming%20crosshair%2C%20optimal%20fps%20display&width=800&height=600&seq=csgo-settings-guide&orientation=landscape',
    author: {
      name: 'ProGamer VN',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20csgo%20player%20portrait%2C%20gaming%20headset%2C%20focused%20expression%2C%20competitive%20gaming%20background&width=100&height=100&seq=author-progamervn&orientation=squarish',
      role: 'Pro Player CS:GO'
    },
    date: '2025-01-01',
    readTime: '9 phút đọc',
    views: '1.8M',
    tags: ['CS:GO', 'Setting', 'Aim', 'Config']
  },
  {
    id: 44,
    title: 'Lịch Sử Esports CS:GO Việt Nam - Từ 1.6 Đến CS2',
    slug: 'lich-su-esports-csgo-viet-nam-tu-1-6-den-cs2',
    excerpt: 'Hành trình phát triển của Counter-Strike tại Việt Nam qua các thời kỳ. Từ CS 1.6 huyền thoại, CS:GO thịnh vượng đến CS2 hiện tại với những cột mốc đáng nhớ và game thủ nổi tiếng.',
    game: 'CS:GO',
    category: 'Tin Game',
    image: 'https://readdy.ai/api/search-image?query=vietnamese%20counter%20strike%20esports%20history%20timeline%2C%20gaming%20evolution%2C%20tournament%20champions%2C%20nostalgic%20gaming%20moments&width=800&height=600&seq=csgo-history-vietnam&orientation=landscape',
    author: {
      name: 'Lão Làng Game',
      avatar: 'https://readdy.ai/api/search-image?query=veteran%20gaming%20journalist%20portrait%2C%20experienced%20gaming%20historian%2C%20nostalgic%20gaming%20background%2C%20wise%20expression&width=100&height=100&seq=author-laolanggame&orientation=squarish',
      role: 'Nhà sử học Gaming'
    },
    date: '2024-12-30',
    readTime: '18 phút đọc',
    views: '1.4M',
    tags: ['CS:GO', 'Lịch sử', 'Esports Việt Nam', 'CS2']
  },

  // PUBG ARTICLES
  {
    id: 5,
    title: 'Viruss - Streamer PUBG Số 1 Việt Nam',
    slug: 'viruss-streamer-pubg-so-1-viet-nam',
    excerpt: 'Câu chuyện thành công của Viruss, từ một game thủ đam mê đến streamer PUBG có lượng fan đông đảo nhất Việt Nam.',
    game: 'PUBG',
    category: 'Game Thủ',
    image: 'https://readdy.ai/api/search-image?query=pubg%20battlegrounds%20gameplay%20action%20scene%2C%20player%20with%20weapon%20in%20battle%20royale%20environment%2C%20intense%20combat%20moment%2C%20high%20quality%20game%20graphics&width=800&height=600&seq=article-5&orientation=landscape',
    author: {
      name: 'Minh Tuấn',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20gaming%20journalist%20avatar%20portrait%2C%20friendly%20smile%2C%20modern%20style%2C%20clean%20background%2C%20high%20quality%20headshot%20photography&width=100&height=100&seq=author-1&orientation=squarish',
      role: 'Biên tập viên Gaming'
    },
    date: '2025-01-11',
    readTime: '9 phút đọc',
    views: '1.1M',
    tags: ['PUBG', 'Viruss', 'Streamer']
  },
  {
    id: 13,
    title: 'PewPew Và Những Pha Clutch Huyền Thoại',
    slug: 'pewpew-va-nhung-pha-clutch-huyen-thoai',
    excerpt: 'Những pha clutch không tưởng của PewPew trong PUBG đã trở thành huyền thoại, tạo nên dấu ấn đặc biệt trong lòng người hâm mộ.',
    game: 'PUBG',
    category: 'Game Thủ',
    image: 'https://readdy.ai/api/search-image?query=pubg%20streamer%20making%20epic%20play%2C%20intense%20battle%20royale%20moment%2C%20exciting%20gameplay%2C%20dramatic%20lighting&width=800&height=600&seq=article-13&orientation=landscape',
    author: {
      name: 'Minh Tuấn',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20gaming%20journalist%20avatar%20portrait%2C%20friendly%20smile%2C%20modern%20style%2C%20clean%20background%2C%20high%20quality%20headshot%20photography&width=100&height=100&seq=author-1&orientation=squarish',
      role: 'Biên tập viên Gaming'
    },
    date: '2025-01-03',
    readTime: '7 phút đọc',
    views: '1.7M',
    tags: ['PUBG', 'PewPew', 'Clutch', 'Streamer']
  },
  {
    id: 45,
    title: 'Hướng Dẫn Setting PUBG PC Tối Ưu Cho FPS Cao Nhất',
    slug: 'huong-dan-setting-pubg-pc-toi-uu-cho-fps-cao-nhat',
    excerpt: 'Những thiết lập game và Windows quan trọng nhất để tối ưu FPS trong PUBG. Từ config game, driver GPU đến các tweak Windows giúp máy yếu vẫn chơi mượt.',
    game: 'PUBG',
    category: 'Hướng Dẫn',
    image: 'https://readdy.ai/api/search-image?query=pubg%20pc%20settings%20optimization%20interface%2C%20high%20fps%20gaming%20setup%2C%20performance%20monitoring%2C%20gaming%20computer%20configuration&width=800&height=600&seq=pubg-fps-guide&orientation=landscape',
    author: {
      name: 'Tech Gaming',
      avatar: 'https://readdy.ai/api/search-image?query=pc%20gaming%20technician%20portrait%2C%20computer%20hardware%20expert%2C%20technical%20support%20specialist%2C%20professional%20tech%20background&width=100&height=100&seq=author-techgaming&orientation=squarish',
      role: 'Chuyên gia Tối ưu PC'
    },
    date: '2024-12-31',
    readTime: '11 phút đọc',
    views: '2.2M',
    tags: ['PUBG', 'FPS', 'Setting', 'Tối ưu']
  },
  {
    id: 46,
    title: 'Top 5 Weapon Combo Mạnh Nhất PUBG 2025',
    slug: 'top-5-weapon-combo-manh-nhat-pubg-2025',
    excerpt: 'Phân tích chi tiết 5 bộ đôi vũ khí hiệu quả nhất trong PUBG hiện tại. Từ combo AR + Sniper đến SMG + DMR, cách sử dụng và tình huống áp dụng tối ưu nhất.',
    game: 'PUBG',
    category: 'Hướng Dẫn',
    image: 'https://readdy.ai/api/search-image?query=pubg%20weapon%20loadout%20showcase%2C%20various%20firearms%20arrangement%2C%20tactical%20weapon%20selection%2C%20military%20equipment%20display&width=800&height=600&seq=pubg-weapon-combo&orientation=landscape',
    author: {
      name: 'BattleRoyale Pro',
      avatar: 'https://readdy.ai/api/search-image?query=pubg%20weapons%20expert%20portrait%2C%20tactical%20gaming%20specialist%2C%20military%20style%20background%2C%20professional%20shooter&width=100&height=100&seq=author-battleroyalepro&orientation=squarish',
      role: 'Chuyên gia Vũ khí PUBG'
    },
    date: '2024-12-29',
    readTime: '10 phút đọc',
    views: '1.6M',
    tags: ['PUBG', 'Weapon', 'Combo', 'Guide']
  },
  {
    id: 47,
    title: 'PUBG Mobile vs PUBG PC - So Sánh Chi Tiết 2025',
    slug: 'pubg-mobile-vs-pubg-pc-so-sanh-chi-tiet-2025',
    excerpt: 'Đánh giá toàn diện sự khác biệt giữa PUBG Mobile và PUBG PC. Phân tích về gameplay, đồ họa, cơ chế điều khiển và cộng đồng người chơi để giúp bạn lựa chọn phiên bản phù hợp.',
    game: 'PUBG',
    category: 'Tin Game',
    image: 'https://readdy.ai/api/search-image?query=pubg%20mobile%20vs%20pc%20comparison%20split%20screen%2C%20smartphone%20and%20computer%20gaming%2C%20battle%20royale%20comparison%2C%20platform%20differences&width=800&height=600&seq=pubg-mobile-vs-pc&orientation=landscape',
    author: {
      name: 'Mobile Gamer',
      avatar: 'https://readdy.ai/api/search-image?query=mobile%20gaming%20expert%20portrait%2C%20smartphone%20and%20pc%20gaming%20setup%2C%20modern%20gaming%20analyst%2C%20tech%20reviewer&width=100&height=100&seq=author-mobilegamer&orientation=squarish',
      role: 'Chuyên gia Gaming Đa nền tảng'
    },
    date: '2024-12-28',
    readTime: '13 phút đọc',
    views: '1.9M',
    tags: ['PUBG', 'Mobile vs PC', 'So sánh', 'Platform']
  }
];

export const trendingArticles = [
  {
    id: 10,
    title: 'Độ Mixi Và Hành Trình Chinh Phục FIFA Online 4',
    slug: 'do-mixi-va-hanh-trinh-chinh-phuc-fifa-online-4',
    thumbnail: 'https://readdy.ai/api/search-image?query=popular%20vietnamese%20streamer%20playing%20fifa%20online%2C%20gaming%20setup%20with%20multiple%20monitors%2C%20energetic%20atmosphere%2C%20modern%20streaming%20room&width=160&height=120&seq=trending-1&orientation=landscape',
    views: '2.3M',
    timeAgo: '2 giờ trước'
  },
  {
    id: 11,
    title: 'Levi - Từ VCS Đến Giấc Mơ Thế Giới',
    slug: 'levi-tu-vcs-den-giac-mo-the-gioi',
    thumbnail: 'https://readdy.ai/api/search-image?query=professional%20league%20of%20legends%20player%20at%20tournament%2C%20focused%20gameplay%2C%20team%20jersey%2C%20competitive%20gaming%20environment&width=160&height=120&seq=trending-2&orientation=landscape',
    views: '1.9M',
    timeAgo: '4 giờ trước'
  },
  {
    id: 12,
    title: 'XuanBac - Huyền Thoại AWP Của CS:GO Việt',
    slug: 'xuanbac-huyen-thoai-awp-cua-csgo-viet',
    thumbnail: 'https://readdy.ai/api/search-image?query=csgo%20professional%20player%20with%20awp%20sniper%20rifle%2C%20intense%20gaming%20moment%2C%20competitive%20match%2C%20focused%20expression&width=160&height=120&seq=trending-3&orientation=landscape',
    views: '1.5M',
    timeAgo: '6 giờ trước'
  },
  {
    id: 13,
    title: 'PewPew Và Những Pha Clutch Huyền Thoại',
    slug: 'pewpew-va-nhung-pha-clutch-huyen-thoai',
    thumbnail: 'https://readdy.ai/api/search-image?query=pubg%20streamer%20making%20epic%20play%2C%20intense%20battle%20royale%20moment%2C%20exciting%20gameplay%2C%20dramatic%20lighting&width=160&height=120&seq=trending-4&orientation=landscape',
    views: '1.7M',
    timeAgo: '8 giờ trước'
  },
  {
    id: 14,
    title: 'Lịch Sử Phát Triển AOE Tại Việt Nam',
    slug: 'lich-su-phat-trien-aoe-tai-viet-nam',
    thumbnail: 'https://readdy.ai/api/search-image?query=age%20of%20empires%20tournament%20in%20vietnam%2C%20players%20competing%2C%20audience%20watching%2C%20esports%20event%20atmosphere&width=160&height=120&seq=trending-5&orientation=landscape',
    views: '1.2M',
    timeAgo: '10 giờ trước'
  }
];

export const streamers = [
  {
    id: 1,
    name: 'Viruss',
    game: 'PUBG',
    avatar: 'https://readdy.ai/api/search-image?query=popular%20vietnamese%20male%20gaming%20streamer%20avatar%2C%20friendly%20smile%2C%20professional%20headshot%2C%20modern%20style&width=128&height=128&seq=streamer-1&orientation=squarish',
    isLive: true,
    viewers: '45.2K'
  },
  {
    id: 2,
    name: 'Độ Mixi',
    game: 'FIFA Online 4',
    avatar: 'https://readdy.ai/api/search-image?query=famous%20vietnamese%20streamer%20portrait%2C%20charismatic%20expression%2C%20professional%20photography%2C%20clean%20background&width=128&height=128&seq=streamer-2&orientation=squarish',
    isLive: true,
    viewers: '38.7K'
  },
  {
    id: 3,
    name: 'PewPew',
    game: 'PUBG',
    avatar: 'https://readdy.ai/api/search-image?query=vietnamese%20gaming%20influencer%20headshot%2C%20confident%20look%2C%20modern%20style%2C%20professional%20portrait&width=128&height=128&seq=streamer-3&orientation=squarish',
    isLive: false,
    viewers: '0'
  }
];

export const esportsSchedule = [
  {
    id: 1,
    time: '19:00',
    date: '2025-01-15',
    teamA: 'GAM Esports',
    teamB: 'Saigon Buffalo',
    tournament: 'VCS Mùa Xuân 2025',
    game: 'LMHT',
    isLive: true
  },
  {
    id: 2,
    time: '20:30',
    date: '2025-01-15',
    teamA: 'Chim Sẻ Đi Nắng',
    teamB: 'BiBi',
    tournament: 'AOE Việt Nam Open',
    game: 'AOE',
    isLive: false
  },
  {
    id: 3,
    time: '14:00',
    date: '2025-01-16',
    teamA: 'SBTC Esports',
    teamB: 'Divine Esports',
    tournament: 'CS:GO Vietnam Championship',
    game: 'CS:GO',
    isLive: false
  },
  {
    id: 4,
    time: '16:00',
    date: '2025-01-16',
    teamA: 'Box Gaming',
    teamB: 'Team Flash',
    tournament: 'PUBG Mobile Vietnam League',
    game: 'PUBG',
    isLive: false
  }
];